/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StationOrLocationAutocompleteFilter
 */
export interface StationOrLocationAutocompleteFilter {
    /**
     * 
     * @type {boolean}
     * @memberof StationOrLocationAutocompleteFilter
     */
    showCountry?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StationOrLocationAutocompleteFilter
     */
    showNonEffective?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StationOrLocationAutocompleteFilter
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof StationOrLocationAutocompleteFilter
     */
    term?: string | null;
}

export function StationOrLocationAutocompleteFilterFromJSON(json: any): StationOrLocationAutocompleteFilter {
    return StationOrLocationAutocompleteFilterFromJSONTyped(json, false);
}

export function StationOrLocationAutocompleteFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationOrLocationAutocompleteFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showCountry': !exists(json, 'showCountry') ? undefined : json['showCountry'],
        'showNonEffective': !exists(json, 'showNonEffective') ? undefined : json['showNonEffective'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'term': !exists(json, 'term') ? undefined : json['term'],
    };
}

export function StationOrLocationAutocompleteFilterToJSON(value?: StationOrLocationAutocompleteFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showCountry': value.showCountry,
        'showNonEffective': value.showNonEffective,
        'limit': value.limit,
        'term': value.term,
    };
}


